import React from 'react'
import '../assets/style.css'
import HeroSlider from './slider'

interface FunctionType{
  onClickHandler:()=>void

}
function Hero({onClickHandler}:FunctionType){
  return (
    <div className='hero'>
        <div className='left'>
        <div>
        <h4>Organic Foood</h4>
        <h1>Fresh Fruite</h1>
        <h1>Spring Sale</h1> 
        <button className='btn' onClick={onClickHandler}>Shop Now</button>
        </div>
       
        </div>
        <div className='right'>
       
        </div>
    </div>
  )
}

export default Hero
